/* eslint-disable no-unused-vars */
import { memo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { calendarSelector } from '@/helpers/props';
import { setBasicFilters } from '@/redux/store/actions/search';
import CalendarDesktop from '@/components/reusable/searchDatePicker/calendarDesktop/CalendarDesktop';
import CalendarMobile from '@/components/reusable/searchDatePicker/calendarMobile/CalendarMobile';
import useDevice from '@/hooks/useDevice';
import FilterChips from '../reusabe/filterChips/FilterChips';
import useDrawer from '@/hooks/useDrawer';
import Box from '@/components/UI/box/Box';
import styles from './DatePicker.module.scss';
import Menu from '@/components/UI/menu/Menu';
import { useRouter } from 'next/router';
const DatePicker = () => {
  const router = useRouter();
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const open = isDrawerOpen('CALENDAR');
  const calendar = useSelector(state => calendarSelector(state, 'searchCalendar'));
  const {
    checkin,
    checkout,
    guests
  } = useSelector(state => state.basicFilters);
  const {
    isMobile
  } = useDevice();
  const dispatch = useDispatch();
  const calendarRef = useRef<any>(null);
  const closeRef = useRef<any>(null);
  const handleClick = () => {
    if (open) {
      drawerClose();
    } else {
      drawerOpen('CALENDAR');
    }
  };
  const submitData = ({
    checkin,
    checkout
  }) => {
    const pageContentSet = {
      '/all-boomgardi': {
        boomgardi: 1
      },
      '/all-cottage': {
        cottage: 1
      }
    };
    const pageQuery = pageContentSet[router.pathname] || {};
    router.push({
      pathname: '/search',
      query: {
        ...pageQuery,
        ...router.query,
        checkin,
        checkout
      }
    });
  };
  const handleDatePickerChange = (dates: any) => {
    dispatch(setBasicFilters({
      checkin: dates.checkin,
      checkout: dates.checkout,
      guests
    }));
    if (dates.submited || !isMobile && dates.checkout) {
      submitData(dates);
    }
  };
  const cleanDatePicker = () => {
    calendarRef.current?.cleanValue();
    dispatch(setBasicFilters({
      checkin: null,
      checkout: null,
      guests
    }));
    const {
      checkin,
      checkout,
      ...restQueries
    } = router.query;
    const pageContentSet = {
      '/all-boomgardi': {
        boomgardi: 1
      },
      '/all-cottage': {
        cottage: 1
      }
    };
    const pageQuery = pageContentSet[router.pathname] || {};
    router.push({
      pathname: '/search',
      query: {
        ...pageQuery,
        ...restQueries
      }
    });
  };
  const resetFilter = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    cleanDatePicker();
  };
  const formatTime = time => {
    const timeDate = new Date(time * 1000);
    const [month, day] = timeDate.toLocaleDateString('fa-IR', {
      day: 'numeric',
      month: 'long'
    }).split(' ');
    return ` ${month} ${day}`;
  };
  return <Box className={styles['filter-item-wrapper']} data-sentry-element="Box" data-sentry-component="DatePicker" data-sentry-source-file="DatePicker.tsx">
      <FilterChips type={'primary'} checked={!!router.query.checkin} handleClick={handleClick} handleClean={resetFilter} label={router.query.checkin && router.query.checkout ? `
            ${formatTime(+router.query.checkin)}
            تا
            ${formatTime(+router.query.checkout)}
          ` : 'انتخاب تاریخ '} startIcon="calendar" endIcon={true} name="date_filter" id="calendar-chips" data-sentry-element="FilterChips" data-sentry-source-file="DatePicker.tsx" />
      {!isMobile ? <Menu ref={closeRef} id="datepicker" menuButtonId="calendar-chips" open={open} handleClose={drawerClose} className={styles['filter-item-container']}>
          <CalendarDesktop calendar={calendar} calendarRef={calendarRef} open={open} checkin={checkin} checkout={checkout} handleChange={handleDatePickerChange} withTooltip={false} />
        </Menu> : <CalendarMobile onClose={drawerClose} open={isDrawerOpen('CALENDAR')} handleDatePickerChange={handleDatePickerChange} resetFilter={cleanDatePicker} calendarRef={calendarRef} withTooltip={false} />}
    </Box>;
};
export default memo(DatePicker);